import styled from 'styled-components';

export const Page = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TabsArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const SkeletonBox = styled.div`
  height: 160px;
  border-radius: ${({ theme }) => theme.radius.lg};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.bgMuted} 0%,
    ${({ theme }) => theme.colors.bgSurface} 50%,
    ${({ theme }) => theme.colors.bgMuted} 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s linear infinite;

  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;
